import {
  await1kke5zj2piplv as await_0,
  awaitOnce2ui7qqi9bvdeq as awaitOnce,
} from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { get_pageNavigator1inl9j7ja0vlf as get_pageNavigator } from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { ClientTermsAndServicesuocndg7xpxyw as ClientTermsAndServices } from '../client/ClientTermsAndServices.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_rawSession1kjo1nj4tz6n0 as get_rawSession } from '../../../sdk/UserSession.mjs';
import {
  modify2eca96i8s7hc2 as modify,
  set_value1vvx5pkb20ebv as set_value,
} from '../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import {
  ProjectState_Invited_getInstancendchtgzjx7u0 as ProjectState_Invited_getInstance,
  UserRole_Customer_getInstance1i1qwr4axl8qb as UserRole_Customer_getInstance,
} from '../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  AnonymousProjectInfo3pqkdqm16et5a as AnonymousProjectInfo,
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
  MonetaryValue__minus_impl_jw9qyp323r7b11udph7 as MonetaryValue__minus_impl_jw9qyp,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
} from '../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { ModificationBuilderuhgnvnxpchbi as ModificationBuilder } from '../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ModificationBuilder.mjs';
import { User8yb1tqk4kykg as User } from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import { get_viewingAnonymousProjects1fofp0ylcs0e6 as get_viewingAnonymousProjects } from '../../../../../../crowpay-shared/com/crowpay/UserFields.mjs';
import { LogInScreen3qovz4fzwtjwv as LogInScreen } from '../auth/LogInScreen.mjs';
import {
  get_selectedApi2skzkr2pn0lot as get_selectedApi,
  get_entries12jrtr1kr2cjq as get_entries,
  ApiOption_Dev_getInstance1m81jm7ijrt5y as ApiOption_Dev_getInstance,
  ApiOption_Local_getInstance3fvnpo9ha9ael as ApiOption_Local_getInstance,
} from '../../../sdk/apiOptions.mjs';
import { confirmationDialog1lynowl7yd4cd as confirmationDialog } from '../../dialogs/GenericConfirmationDialog.mjs';
import { UserRegistration2mhykjk2xa45 as UserRegistration } from '../auth/UserRegistration.mjs';
import {
  _EmailAddress___init__impl__a6ugvr3vyholn0wwoi2 as _EmailAddress___init__impl__a6ugvr,
  _PhoneNumber___init__impl__slwhzyo93bblbw66x0 as _PhoneNumber___init__impl__slwhzy,
} from '../../../../../../lightning-server-shared/com/lightningkite/StringAlts.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { LsErrorException1ikb4g50zc2ko as LsErrorException } from '../../../../../../lightning-server-kiteui-client/com/lightningkite/lightningserver/LsErrorException.mjs';
import { contains3ue2qo8xhmpf1 as contains } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  ExceptionMessage21t2b5aa8xtox as ExceptionMessage,
  Companion_getInstance37g5wqg3e7ywq as Companion_getInstance,
  Companion_instance2x38zxm4t0kdk as Companion_instance_0,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/exceptions/handling.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import {
  ProjectView3mpzjwcpohxct as ProjectView,
  ProjectLens_Preview_getInstance1ljkez32qkuib as ProjectLens_Preview_getInstance,
} from './ProjectView.mjs';
import {
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
  LateInitSignal30crwrg540xyy as LateInitSignal,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { println2shhhgwwt4c61 as println } from '../../../../../../kotlin-kotlin-stdlib/kotlin/io/console.mjs';
import { LogRoot_getInstance3817ahbflvs01 as LogRoot_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/debugger.js.mjs';
import { startsWith26w8qjqapeeq6 as startsWith } from '../../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { mutableRememberSuspending34dudnx7ur0xn as mutableRememberSuspending } from '../../../../../../reactive/com/lightningkite/reactive/core/MutableRememberSuspending.mjs';
import { sortedWith2csnbbb21k0lg as sortedWith } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { AdjustedLineItemjcq04uf63gb9 as AdjustedLineItem } from '../../../utils/AdjustedLineItem.mjs';
import { setOf1u3mizs95ngxo as setOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { emptyMapr06gerzljqtm as emptyMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { isPendingCompletion65tdr7y6lgp6 as isPendingCompletion } from '../../../../../../crowpay-shared/com/crowpay/statePermissions.mjs';
import {
  get_status1qu684t7g7eh as get_status,
  PayAppStatus_Pending_getInstance2ma8qo3my1dmm as PayAppStatus_Pending_getInstance,
} from '../../components/project/work/payApps/data.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import { inviteView2x3od30x7hoe5 as inviteView } from '../../components/project/inviteView.mjs';
import { handleAuthRendering280086oqucnha as handleAuthRendering } from '../auth/handleAuthRendering.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$mutableRememberSuspending, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.bj4_1.nf1_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.dfx().rfg_1.gfp($this.bj4_1.kf1_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp = awaitOnce($this.cj4_1.of1_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var p = tmp;
  var tmp_0 = get_pageNavigator($this.dj4_1);
  // Inline function 'kotlin.apply' call
  var this_0 = new (ClientTermsAndServices())(p.w9w_1.v7a_1);
  this_0.nf8_1 = p;
  tmp_0.fbw(this_0);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, $this$launch, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_rawSession();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_elvis_lhs = tmp;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var session = tmp_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.ej4_1.pf1_1;
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var p = tmp_1;
  if (p.u7b_1.equals(ProjectState_Invited_getInstance())) {
    var tmp_2 = session.vfw().rfg_1.hfp(p.v7a_1, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    var updated = tmp_2;
    var tmp_3 = modify($this.ej4_1.of1_1, AnonymousProjectView$renderMainContent$lambda$slambda$slambda_0(updated), $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  }
  return Unit_instance;
}
var AnonymousProjectView$renderMainContent$lambda$slambda$slambdaClass;
function AnonymousProjectView$renderMainContent$lambda$slambda$slambda() {
  if (AnonymousProjectView$renderMainContent$lambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($updated) {
        this.fj4_1 = $updated;
      }
      gj4(it, $completion) {
        return it.d9x(this.fj4_1);
      }
      s2(p1, $completion) {
        return this.gj4(p1 instanceof AnonymousProjectInfo() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    AnonymousProjectView$renderMainContent$lambda$slambda$slambdaClass = $;
  }
  return AnonymousProjectView$renderMainContent$lambda$slambda$slambdaClass;
}
function AnonymousProjectView$renderMainContent$lambda$slambda$slambda_0($updated) {
  var i = new (AnonymousProjectView$renderMainContent$lambda$slambda$slambda())($updated);
  var l = (it, $completion) => i.gj4(it, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_2($this, $this$launch, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_rawSession();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_elvis_lhs = tmp;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var session = tmp_0;
  // Inline function 'com.crowpay.utils.modify2' call
  var this_1 = session.afw_1.geo(session.gfv_1);
  // Inline function 'com.lightningkite.lightningdb.modification' call
  // Inline function 'kotlin.apply' call
  var this_2 = new (ModificationBuilder())();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_1 = serializerOrContextual(createKType(getKClass(User()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
  var it = new (DataClassPathSelf())(tmp$ret$1);
  this_2.e44(get_viewingAnonymousProjects(it), $this.hj4_1.kf1_1);
  var tmp$ret$6 = this_2.m1r();
  var tmp_2 = this_1.nen(tmp$ret$6, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return Unit_instance;
}
function *_generator_onLogin__pgjcye($this, _this__u8e3s4, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.nf1_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var api = tmp;
  var tmp_0 = get_pageNavigator(_this__u8e3s4);
  // Inline function 'kotlin.apply' call
  var this_1 = new (LogInScreen())();
  this_1.fir($this);
  var tmp_1 = get_selectedApi().iah(api, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  tmp_0.fbw(this_1);
  return Unit_instance;
}
function *_generator_onAccept__x1dom7($this, _this__u8e3s4, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.pf1_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  var tmp_0 = 'Accept Project - ' + MonetaryValue__toString_impl_xslc77(tmp$ret$0.w7b_1) + '?';
  confirmationDialog(_this__u8e3s4, tmp_0, "Accepting this project confirms that you have reviewed and agreed to the project details. Please check everything is correct, as changes after this step will need both parties to agree. Click 'Accept' and proceed to review Stoze's Terms of Service for escrow project protection.", 'Accept Project', VOID, VOID, VOID, VOID, VOID, VOID, AnonymousProjectView$onAccept$slambda_0($this, _this__u8e3s4));
  return Unit_instance;
}
function *_generator_onRegister__xqkuze($this, _this__u8e3s4, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.nf1_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var api = tmp;
  var tmp_0 = get_pageNavigator(_this__u8e3s4);
  // Inline function 'kotlin.apply' call
  var this_1 = new (UserRegistration())();
  this_1.fir($this);
  var tmp_1 = this_1;
  var tmp_2 = await_0($this.of1_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  tmp_1.nev_1 = tmp_2;
  this_1.oev_1 = api;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = $this.sf1_1;
  var tmp_3 = await_0(this_2, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var client = tmp_3;
  var tmp0_email = _EmailAddress___init__impl__a6ugvr(client.g5c_1);
  var tmp1_phoneNumber = _PhoneNumber___init__impl__slwhzy(client.h5c_1);
  var tmp2_address = client.i5c_1;
  var tmp3_firstName = client.e5c_1;
  var tmp4_lastName = client.f5c_1;
  var tmp5_role = UserRole_Customer_getInstance();
  set_value(this_1.pev_1, new (User())(VOID, tmp0_email, tmp1_phoneNumber, VOID, tmp3_firstName, tmp4_lastName, tmp2_address, VOID, VOID, tmp5_role));
  tmp_0.fbw(this_1);
  return Unit_instance;
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.ij4_1 = function_0;
      }
      wi(a, b) {
        return this.ij4_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.ij4_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
var AnonymousProjectView$$inlined$invoke$1Class;
function AnonymousProjectView$$inlined$invoke$1() {
  if (AnonymousProjectView$$inlined$invoke$1Class === VOID) {
    class $ {
      constructor($priority) {
        this.jj4_1 = $priority;
      }
      g90() {
        return this.jj4_1;
      }
      bcw(view, exception) {
        if (!(exception instanceof LsErrorException()))
          return null;
        var tmp0_safe_receiver = exception.message;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : contains(tmp0_safe_receiver, 'You must be authorized as a ???');
        if (!(tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs))
          return null;
        return new (ExceptionMessage())('Link Expired', 'The link are using has expired, please acquire a new link to continue viewing anonymously.');
      }
    }
    initMetadataForClass($);
    AnonymousProjectView$$inlined$invoke$1Class = $;
  }
  return AnonymousProjectView$$inlined$invoke$1Class;
}
var AnonymousProjectView$projectData$slambdaClass;
function AnonymousProjectView$projectData$slambda() {
  if (AnonymousProjectView$projectData$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.bj4_1 = this$0;
      }
      yah($this$mutableRememberSuspending, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$mutableRememberSuspending), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    AnonymousProjectView$projectData$slambdaClass = $;
  }
  return AnonymousProjectView$projectData$slambdaClass;
}
function AnonymousProjectView$projectData$slambda_0(this$0) {
  var i = new (AnonymousProjectView$projectData$slambda())(this$0);
  var l = ($this$mutableRememberSuspending, $completion) => i.yah($this$mutableRememberSuspending, $completion);
  l.$arity = 1;
  return l;
}
function AnonymousProjectView$lineItems$lambda$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.m6k_1;
  var tmp$ret$1 = b.m6k_1;
  return compareValues(tmp, tmp$ret$1);
}
var AnonymousProjectView$onAccept$slambdaClass;
function AnonymousProjectView$onAccept$slambda() {
  if (AnonymousProjectView$onAccept$slambdaClass === VOID) {
    class $ {
      constructor(this$0, $this_onAccept) {
        this.cj4_1 = this$0;
        this.dj4_1 = $this_onAccept;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    AnonymousProjectView$onAccept$slambdaClass = $;
  }
  return AnonymousProjectView$onAccept$slambdaClass;
}
function AnonymousProjectView$onAccept$slambda_0(this$0, $this_onAccept) {
  var i = new (AnonymousProjectView$onAccept$slambda())(this$0, $this_onAccept);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
var AnonymousProjectView$renderMainContent$lambda$slambdaClass;
function AnonymousProjectView$renderMainContent$lambda$slambda() {
  if (AnonymousProjectView$renderMainContent$lambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.ej4_1 = this$0;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    AnonymousProjectView$renderMainContent$lambda$slambdaClass = $;
  }
  return AnonymousProjectView$renderMainContent$lambda$slambdaClass;
}
function AnonymousProjectView$renderMainContent$lambda$slambda_0(this$0) {
  var i = new (AnonymousProjectView$renderMainContent$lambda$slambda())(this$0);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var AnonymousProjectView$renderMainContent$lambda$slambdaClass_0;
function AnonymousProjectView$renderMainContent$lambda$slambda_1() {
  if (AnonymousProjectView$renderMainContent$lambda$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.hj4_1 = this$0;
      }
      yah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.yah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    AnonymousProjectView$renderMainContent$lambda$slambdaClass_0 = $;
  }
  return AnonymousProjectView$renderMainContent$lambda$slambdaClass_0;
}
function AnonymousProjectView$renderMainContent$lambda$slambda_2(this$0) {
  var i = new (AnonymousProjectView$renderMainContent$lambda$slambda_1())(this$0);
  var l = ($this$launch, $completion) => i.yah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var AnonymousProjectViewClass;
function AnonymousProjectView() {
  if (AnonymousProjectViewClass === VOID) {
    class $ extends ProjectView() {
      constructor(projectId) {
        super(ProjectLens_Preview_getInstance());
        this.kf1_1 = projectId;
        this.lf1_1 = new (Constant())(_Constant___init__impl__v45mub('Project Preview'));
        var tmp = Companion_getInstance().jcw_1;
        // Inline function 'com.lightningkite.kiteui.exceptions.Companion.invoke' call
        var tmp$ret$0 = new (AnonymousProjectView$$inlined$invoke$1())(2.0);
        tmp.icw(tmp$ret$0);
        this.mf1_1 = LateInitSignal().taq();
        var tmp_0 = this;
        tmp_0.nf1_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          println('In ApiOptions');
          // Inline function 'kotlin.also' call
          var this_0 = $this$remember.daj(this.mf1_1);
          println('Server ' + this_0);
          var server = this_0;
          var tmp;
          if (!startsWith(server, 'https')) {
            LogRoot_getInstance().icv(['Using local api']);
            tmp = ApiOption_Local_getInstance();
          } else {
            // Inline function 'kotlin.collections.find' call
            var tmp0 = get_entries();
            var tmp$ret$4;
            $l$block: {
              // Inline function 'kotlin.collections.firstOrNull' call
              var _iterator__ex2g4s = tmp0.m1();
              while (_iterator__ex2g4s.n1()) {
                var element = _iterator__ex2g4s.o1();
                if (element.afx_1 === server) {
                  tmp$ret$4 = element;
                  break $l$block;
                }
              }
              tmp$ret$4 = null;
            }
            var tmp0_elvis_lhs = tmp$ret$4;
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              // Inline function 'kotlin.run' call
              LogRoot_getInstance().icv(['COULD NOT FIND SERVER ' + server + ' FOR API OPTION']);
              tmp_0 = ApiOption_Dev_getInstance();
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }
            tmp = tmp_0;
          }
          var s = tmp;
          println('Found ' + s.toString());
          get_selectedApi().oam(s);
          println('Set ' + s.toString());
          return s;
        });
        var tmp_1 = this;
        tmp_1.of1_1 = mutableRememberSuspending(VOID, VOID, AnonymousProjectView$projectData$slambda_0(this));
        var tmp_2 = this;
        tmp_2.pf1_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj(this.of1_1).w9w_1);
        var tmp_3 = this;
        tmp_3.qf1_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp0_safe_receiver = $this$remember.daj(get_rawSession());
          var self_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.gfv_1;
          var tmp = $this$remember.daj(this.of1_1).z9w_1;
          // Inline function 'kotlin.comparisons.compareBy' call
          var tmp_0 = AnonymousProjectView$lineItems$lambda$lambda;
          // Inline function 'kotlin.comparisons.thenBy' call
          var this_0 = new (sam$kotlin_Comparator$0())(tmp_0);
          var tmp_1 = (a, b) => {
            var previousCompare = this_0.compare(a, b);
            var tmp;
            if (!(previousCompare === 0)) {
              tmp = previousCompare;
            } else {
              // Inline function 'kotlin.comparisons.compareValuesBy' call
              var tmp_0 = a.j6k_1;
              var tmp$ret$10 = b.j6k_1;
              tmp = compareValues(tmp_0, tmp$ret$10);
            }
            return tmp;
          };
          var tmp$ret$12 = new (sam$kotlin_Comparator$0())(tmp_1);
          // Inline function 'kotlin.collections.map' call
          var this_1 = sortedWith(tmp, tmp$ret$12);
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().u(collectionSizeOrDefault(this_1, 10));
          var _iterator__ex2g4s = this_1.m1();
          while (_iterator__ex2g4s.n1()) {
            var item = _iterator__ex2g4s.o1();
            var tmp$ret$13 = AdjustedLineItem().jfy(self_0 == null ? item : item.g6l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, setOf(self_0)), emptyList());
            destination.v(tmp$ret$13);
          }
          return destination;
        });
        var tmp_4 = this;
        tmp_4.rf1_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp0_safe_receiver = $this$remember.daj(get_rawSession());
          var self_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.gfv_1;
          // Inline function 'kotlin.let' call
          var it = $this$remember.daj(this.of1_1).a9x_1;
          var tmp;
          if (self_0 == null) {
            tmp = it;
          } else {
            // Inline function 'kotlin.collections.map' call
            // Inline function 'kotlin.collections.mapTo' call
            var destination = ArrayList().u(collectionSizeOrDefault(it, 10));
            var _iterator__ex2g4s = it.m1();
            while (_iterator__ex2g4s.n1()) {
              var item = _iterator__ex2g4s.o1();
              var tmp$ret$16 = item.s7z(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, setOf(self_0));
              destination.v(tmp$ret$16);
            }
            tmp = destination;
          }
          return tmp;
        });
        var tmp_5 = this;
        tmp_5.sf1_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj(this.of1_1).x9w_1);
        var tmp_6 = this;
        tmp_6.tf1_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.daj(this.of1_1).y9w_1);
        this.uf1_1 = new (Constant())(_Constant___init__impl__v45mub(emptyList()));
        this.vf1_1 = new (Constant())(_Constant___init__impl__v45mub(emptyList()));
        this.wf1_1 = new (Constant())(_Constant___init__impl__v45mub(emptyList()));
        this.xf1_1 = new (Constant())(_Constant___init__impl__v45mub(emptyList()));
        this.yf1_1 = new (Constant())(_Constant___init__impl__v45mub(emptyList()));
        this.zf1_1 = new (Constant())(_Constant___init__impl__v45mub(emptyList()));
        this.af2_1 = new (Constant())(_Constant___init__impl__v45mub(emptyList()));
        this.bf2_1 = new (Constant())(_Constant___init__impl__v45mub(emptyList()));
        this.cf2_1 = new (Constant())(_Constant___init__impl__v45mub(emptyList()));
        this.df2_1 = new (Constant())(_Constant___init__impl__v45mub(emptyList()));
        this.ef2_1 = new (Constant())(_Constant___init__impl__v45mub(emptyList()));
        this.ff2_1 = new (Constant())(_Constant___init__impl__v45mub(emptyList()));
        this.gf2_1 = new (Constant())(_Constant___init__impl__v45mub(emptyList()));
        this.hf2_1 = new (Constant())(_Constant___init__impl__v45mub(emptyList()));
        this.if2_1 = new (Constant())(_Constant___init__impl__v45mub(emptyMap()));
        this.jf2_1 = new (Constant())(_Constant___init__impl__v45mub(emptyMap()));
        this.kf2_1 = new (Constant())(_Constant___init__impl__v45mub(emptyList()));
        this.lf2_1 = new (Constant())(_Constant___init__impl__v45mub(emptyList()));
        this.mf2_1 = new (Constant())(_Constant___init__impl__v45mub(emptyList()));
        this.nf2_1 = new (Constant())(_Constant___init__impl__v45mub(emptyList()));
        this.of2_1 = new (Constant())(_Constant___init__impl__v45mub(null));
        var tmp_7 = this;
        tmp_7.pf2_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var p = $this$remember.daj(this.pf1_1);
          var draws = $this$remember.daj(this.xf1_1);
          var items = $this$remember.daj(this.qf1_1);
          // Inline function 'kotlin.collections.filter' call
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = items.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if (isPendingCompletion(element.mfy())) {
              destination.v(element);
            }
          }
          // Inline function 'com.crowpay.extensions.sumMoney' call
          var sum = Companion_instance.r91(0n);
          var _iterator__ex2g4s_0 = destination.m1();
          while (_iterator__ex2g4s_0.n1()) {
            var element_0 = _iterator__ex2g4s_0.o1();
            var tmp = sum;
            var tmp$ret$24 = element_0.jf9_1.q91();
            sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$24);
          }
          var workPending = sum;
          // Inline function 'kotlin.collections.filter' call
          // Inline function 'kotlin.collections.filterTo' call
          var destination_0 = ArrayList().w();
          var _iterator__ex2g4s_1 = draws.m1();
          while (_iterator__ex2g4s_1.n1()) {
            var element_1 = _iterator__ex2g4s_1.o1();
            if (get_status(element_1).equals(PayAppStatus_Pending_getInstance())) {
              destination_0.v(element_1);
            }
          }
          // Inline function 'com.crowpay.extensions.sumMoney' call
          var sum_0 = Companion_instance.r91(0n);
          var _iterator__ex2g4s_2 = destination_0.m1();
          while (_iterator__ex2g4s_2.n1()) {
            var element_2 = _iterator__ex2g4s_2.o1();
            var tmp_0 = sum_0;
            var tmp$ret$29 = element_2.r6v_1;
            sum_0 = MonetaryValue__plus_impl_c1ylt(tmp_0, tmp$ret$29);
          }
          var drawsPending = sum_0;
          return new (MonetaryValue())(MonetaryValue__minus_impl_jw9qyp(MonetaryValue__minus_impl_jw9qyp(p.u97(), workPending), drawsPending));
        });
      }
      lf8() {
        return this.kf1_1;
      }
      wcv() {
        return this.lf1_1;
      }
      lfy() {
        return this.pf1_1;
      }
      vgm() {
        return this.qf1_1;
      }
      ngy() {
        return this.rf1_1;
      }
      ygk() {
        return this.sf1_1;
      }
      hgl() {
        return this.tf1_1;
      }
      xgv() {
        return this.uf1_1;
      }
      mgz() {
        return this.vf1_1;
      }
      zgz() {
        return this.wf1_1;
      }
      jgt() {
        return this.xf1_1;
      }
      fgt() {
        return this.yf1_1;
      }
      kgt() {
        return this.zf1_1;
      }
      lgt() {
        return this.af2_1;
      }
      wgm() {
        return this.bf2_1;
      }
      dgt() {
        return this.cf2_1;
      }
      igt() {
        return this.df2_1;
      }
      egt() {
        return this.ef2_1;
      }
      kj3() {
        return this.ff2_1;
      }
      hgt() {
        return this.gf2_1;
      }
      ggt() {
        return this.hf2_1;
      }
      tgt() {
        return this.if2_1;
      }
      ogf() {
        return this.jf2_1;
      }
      pgf() {
        return this.kf2_1;
      }
      qh2() {
        return this.lf2_1;
      }
      lj3() {
        return this.mf2_1;
      }
      vgj() {
        return this.nf2_1;
      }
      wgj() {
        return this.of2_1;
      }
      uh2() {
        return this.pf2_1;
      }
      sgm(_this__u8e3s4, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_onLogin__pgjcye.bind(VOID, this, _this__u8e3s4), $completion);
      }
      xgl(_this__u8e3s4, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_onAccept__x1dom7.bind(VOID, this, _this__u8e3s4), $completion);
      }
      pgm(_this__u8e3s4, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_onRegister__xqkuze.bind(VOID, this, _this__u8e3s4), $completion);
      }
      uhf(_this__u8e3s4) {
        return handleAuthRendering(_this__u8e3s4, true, VOID, ($this$handleAuthRendering, isLoggedIn) => {
          launch($this$handleAuthRendering, VOID, VOID, AnonymousProjectView$renderMainContent$lambda$slambda_0(this));
          launch($this$handleAuthRendering, VOID, VOID, AnonymousProjectView$renderMainContent$lambda$slambda_2(this));
          if (isLoggedIn) {
            this.nj3($this$handleAuthRendering);
          } else {
            inviteView(this, $this$handleAuthRendering);
          }
          return Unit_instance;
        });
      }
    }
    initMetadataForClass($, 'AnonymousProjectView', VOID, VOID, VOID, [1]);
    AnonymousProjectViewClass = $;
  }
  return AnonymousProjectViewClass;
}
//region block: exports
export {
  AnonymousProjectView as AnonymousProjectView24hg9uw1el0c2,
};
//endregion

//# sourceMappingURL=AnonymousProjectView.mjs.map
